import { PaymentOrderDraft } from "../../../contexts/IHCCDraftContext/IHCCDraftContext.types";

export function GridItemIsNotEmpty(item: PaymentOrderDraft) {
  return item.opAccount || item.transType || item.transAmount || item.transCurrency || item.rpAccount || item.purpose;
}
